import { Box, List, Button, Typography } from "@material-ui/core";
import React from "react";
import { useHistory } from "react-router-dom";
import DrawerComponent from "./Dashboard/Dashboard-Component/DrawerComponent";
import usePathStyles from "./Report/src/Component/Share/usePathStyles";

export default function RankingPath() {
  const classes = usePathStyles();
  const history = useHistory();
  return (
    <Box className={classes.container}>
      <DrawerComponent onReport />
      <Typography className={classes.title} variant="h2" align="center">
        Ranking
      </Typography>
      <List>
        {[
          ["Top Products", "ranking/product", false],
          ["Top Product Categories", "ranking/category", false],
          ["Top Payment Methods", "ranking/payment", false],
          ["Top Big Spender", "ranking/bigspender", false],
          ["Top Frequent Members", "ranking/frequent", false],
        ].map((text) => (
          <Box>
            <Button
              variant={"outlined"}
              className={classes.button}
              disabled={text[2]}
              onClick={() => {
                history.push({
                  pathname: "/bi/report/" + text[1],
                });
              }}
            >
              {text[0]}
            </Button>
          </Box>
        ))}
      </List>
    </Box>
  );
}
